import { Box } from "./Box"
import { BoxProps } from "./types"

export const Card = ({children, ...props}:BoxProps) => {
    return <Box className="card card-custom gutter-b p-6" {...props}>
        {children}
    </Box>
}
